$(document).ready(function () {
  
  jQuery('.cart__checkout').click(function(){
    window.location.href = "/checkout"
  })
  
  // By default, the filter will be open along with the loading.
  $("summary.filter-group__heading").click();
  $(".collection__sidebar").css("opacity", "1");

  // Replace the symbol on product page
  setTimeout(function () {
  $(".spb-label-tooltip .spb-tooltip").each(function () {
    var htmlContent = $(this).html();
    var updatedContent = htmlContent.replace("ⓘ", "");
    $(this).html(updatedContent);
    $("#infiniteoptions-container .spb-tooltip").css("opacity", "1");
  });
}, 4200);

  $("summary.cart__widget__title").click();
  $("details.accordion:nth-child(1) summary.accordion__title.h6").click();
  // $("details.cart__widget.cart__widget--products.accordion").css("pointer-events", "none");

    $('.btn--ar product-single__view-in-space').click(function(){
      console.log('3d click div');
        $('.product__media.deferred-media').click();
    });
    
      $('.btn--ar product-single__view-in-space').click(function(){
        console.log('3d click btn');
        $('.product__media.deferred-media button').click();
    });

  
});
